// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3Y5mQ","ranges":"BmiRanges_ranges__yawI-"};